import { useEffect, useState } from "react";
import useAxios from "../../utils/useAxios";
import { FaLink, FaSpinner } from "react-icons/fa";
import Select from "react-select";
import Pagination from "../common/pagination";

function Properties() {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [locations, setLocations] = useState([]);
  const [amenitiesOptions, setAmenitiesOptions] = useState([]);
  const [selectedAmenities, setSelectedAmenities] = useState([]);
  const [gridPosition, setGridPosition] = useState("row");
  const [uploadedMedia, setUploadedMedia] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [mediaType, setMediaType] = useState(""); // 'image' or 'video'
  const [media, setMedia] = useState([]);
  const [selectedPreview, setSelectedPreview] = useState(null); //  preview URL
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [shouldFetch, setShouldFetch] = useState(false);
  const [categoryItems, setCategoryItems] = useState([]);
  const [category, setCategory] = useState([]);

  const [selectionType, setSelectionType] = useState("multiple");

  const axiosAPI = useAxios();

  const [builders, setBuilders] = useState([]);

  const [filters, setFilters] = useState({
    search: "",
  });

  const buildQuery = () => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value) params.append(key, value);
    });

    params.append("page", page);
    return params.toString();
  };

  const handleResetFilters = () => {
    setFilters({
      search: "",
    });
    getProperty();
    setShouldFetch(true);
  };

  const DEFAULT_TIMELINE_TEMPLATE = [
    {
      title: "Land Acquisition & Title Due Diligence",
      description: "Clear 30-year title deeds, ADA layout sanction, and UP RERA registration obtained.",
      status: "completed",
    },
    {
      title: "Excavation, Piling & Foundation",
      description: "Deep RCC foundation and basement waterproofing completed with certified structural quality audit.",
      status: "completed",
    },
    {
      title: "Superstructure & Slab Casting",
      description: "Tower slabs and brickwork in progress. On track as per UP RERA committed possession schedule.",
      status: "current",
    },
    {
      title: "MEP, Interior Finishing & Lifts",
      description: "Electrical conduits, plumbing lines, flooring tiles, and branded high-speed elevators installation.",
      status: "pending",
    },
    {
      title: "Occupancy Certificate (OC) & Handover",
      description: "Final municipal inspections, registry execution, and key handover ceremony for buyers.",
      status: "pending",
    },
  ];

  const DEFAULT_LANDMARKS_TEMPLATE = [
    {
      landmark_name: "Agra-Lucknow Expressway Interchange",
      category: "Expressway",
      distance: "4.2 km",
      drive_time: "7 Mins",
    },
    {
      landmark_name: "National Highway 19 (Delhi-Agra NH-2)",
      category: "National Highway",
      distance: "1.8 km",
      drive_time: "4 Mins",
    },
    {
      landmark_name: "Raja Ki Mandi Railway Station",
      category: "Railway",
      distance: "6.5 km",
      drive_time: "12 Mins",
    },
    {
      landmark_name: "St. Conrad's & DPS Educational Hub",
      category: "School",
      distance: "3.0 km",
      drive_time: "6 Mins",
    },
    {
      landmark_name: "Upcoming Noida International Airport (Jewar Corridor)",
      category: "Airport Corridor",
      distance: "Direct Transit",
      drive_time: "Express Access",
    },
  ];

  const initialFormData = {
    propertyName: "",
    mediaUrl: "",
    thumbnailUrl: "",
    fileType: "",
    propertyType: "",
    propertyUseType: "",
    propertyCategory: "",
    propertySellingPrice: "",
    propertyAddress: "",
    latitude: "",
    longitude: "",
    brochureFile: null,
    existingBrochure: "",
    availabilityStatus: "",
    propertyDetails: [
      {
        srNo: "",
        area: "",
        floor: "",
        isAvailable: true,
      },
    ],
    builder_id: "",
    propertyArea: "",
    rooms: "",
    bedRooms: "",
    bathRooms: "",
    state: "",
    city: "",
    location: "",
    amenities: [],
    propertySlug: "",
    mediaIds: [],
    thumbnail_media_id: null,
    category_ids: [],
    heading: "",
    description: "",
    timeline: [],
    landmarks: [],
    timelineUpdatedDate: "Updated October 2026",
  };

  const [formData, setFormData] = useState(initialFormData);

  // Standalone Quick Timeline & Landmarks Modal states
  const [timelineModalOpen, setTimelineModalOpen] = useState(false);
  const [selectedPropertyForExtras, setSelectedPropertyForExtras] = useState(null);
  const [extraTimeline, setExtraTimeline] = useState([]);
  const [extraLandmarks, setExtraLandmarks] = useState([]);
  const [extraUpdatedDate, setExtraUpdatedDate] = useState("Updated October 2026");
  const [isSavingExtras, setIsSavingExtras] = useState(false);
  const [extrasActiveTab, setExtrasActiveTab] = useState("timeline");

  const removeFormData = () => {
    setFormData(initialFormData);
    setSelectedAmenities([]);
  };

  // Timeline handlers for main form
  const handleAddTimelineStage = () => {
    setFormData((prev) => ({
      ...prev,
      timeline: [
        ...(prev.timeline || []),
        {
          title: "",
          description: "",
          status: "pending",
        },
      ],
    }));
  };

  const handleUpdateTimelineStage = (index, field, value) => {
    setFormData((prev) => {
      const updated = [...(prev.timeline || [])];
      updated[index] = { ...updated[index], [field]: value };
      return { ...prev, timeline: updated };
    });
  };

  const handleRemoveTimelineStage = (index) => {
    setFormData((prev) => {
      const updated = [...(prev.timeline || [])];
      updated.splice(index, 1);
      return { ...prev, timeline: updated };
    });
  };

  const handleLoadDefaultTimeline = () => {
    setFormData((prev) => ({
      ...prev,
      timeline: DEFAULT_TIMELINE_TEMPLATE,
    }));
  };

  // Landmark handlers for main form
  const handleAddLandmark = () => {
    setFormData((prev) => ({
      ...prev,
      landmarks: [
        ...(prev.landmarks || []),
        {
          landmark_name: "",
          category: "Expressway",
          distance: "",
          drive_time: "",
        },
      ],
    }));
  };

  const handleUpdateLandmark = (index, field, value) => {
    setFormData((prev) => {
      const updated = [...(prev.landmarks || [])];
      updated[index] = { ...updated[index], [field]: value };
      return { ...prev, landmarks: updated };
    });
  };

  const handleRemoveLandmark = (index) => {
    setFormData((prev) => {
      const updated = [...(prev.landmarks || [])];
      updated.splice(index, 1);
      return { ...prev, landmarks: updated };
    });
  };

  const handleLoadDefaultLandmarks = () => {
    setFormData((prev) => ({
      ...prev,
      landmarks: DEFAULT_LANDMARKS_TEMPLATE,
    }));
  };

  // Standalone Quick Modal Handlers
  const openTimelineLandmarksModal = async (property) => {
    setSelectedPropertyForExtras(property);
    setTimelineModalOpen(true);
    setExtrasActiveTab("timeline");
    try {
      const res = await axiosAPI.get(`/api/properties/timeline-landmarks/${property.id}`);
      if (res?.data?.success) {
        const t = res.data.timeline || [];
        const l = res.data.landmarks || [];
        setExtraTimeline(t.length > 0 ? t : DEFAULT_TIMELINE_TEMPLATE);
        setExtraLandmarks(l.length > 0 ? l : DEFAULT_LANDMARKS_TEMPLATE);
        setExtraUpdatedDate(t[0]?.updated_date || "Updated October 2026");
      } else {
        setExtraTimeline(DEFAULT_TIMELINE_TEMPLATE);
        setExtraLandmarks(DEFAULT_LANDMARKS_TEMPLATE);
      }
    } catch (err) {
      setExtraTimeline(DEFAULT_TIMELINE_TEMPLATE);
      setExtraLandmarks(DEFAULT_LANDMARKS_TEMPLATE);
    }
  };

  const handleSaveExtras = async () => {
    if (!selectedPropertyForExtras) return;
    setIsSavingExtras(true);
    try {
      const timelineWithDate = (extraTimeline || []).map((item, idx) => ({
        ...item,
        order_index: idx,
        updated_date: extraUpdatedDate,
      }));
      const landmarksWithIndex = (extraLandmarks || []).map((item, idx) => ({
        ...item,
        order_index: idx,
      }));
      await axiosAPI.post(
        `/api/properties/timeline-landmarks/${selectedPropertyForExtras.id}`,
        {
          timeline: timelineWithDate,
          landmarks: landmarksWithIndex,
        }
      );
      window.notifyMessage(
        "Success",
        "Timeline and Landmarks updated successfully!",
        "success"
      );
      setTimelineModalOpen(false);
    } catch (err) {
      console.error(err);
      window.notifyMessage("Error", "Failed to save timeline & landmarks", "danger");
    } finally {
      setIsSavingExtras(false);
    }
  };

  async function fetchCategory() {
    try {
      setLoading(true);
      const response = await axiosAPI.get("/api/categories");

      const categories = response?.data?.categories;

      const limitedData = categories?.map(({ id, name }) => ({
        id,
        name,
      }));

      setCategory(limitedData);
      setTotalPages(response?.data?.totalPages);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      // Always turn off loading, whether success or error
      setLoading(false);
    }
  }

  // console.log("Category", category);

  const categoryOptions = category?.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  // Handle select change
  const handleAmenitiesChange = (selected) => {
    setSelectedAmenities(selected);

    // Set selected amenity IDs in formData
    const selectedIds = selected.map((item) => item.value);

    // console.log("s ids", selectedIds);

    setFormData({
      ...formData,
      ammenities: selectedIds,
    });
  };

  // Get All Notifications
  const getProperty = async () => {
    try {
      setLoading(true);
      const queryString = buildQuery();

      const response = await axiosAPI.get(
        `/api/properties/get-dashboard-properties?${queryString}`,
      );
      //   console.log(response.data);
      setProperties(response?.data?.data);
      setTotalPages(response?.data?.totalPages);

      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const getData = async () => {
    try {
      const [citiesRes, locationsRes, statesRes, builderRes] =
        await Promise.all([
          axiosAPI.get("/api/properties/get-cities"),
          axiosAPI.get("/api/properties/get-locations"),
          axiosAPI.get("/api/properties/get-states"),
          axiosAPI.get("/api/builder/get-builders"),
        ]);

      setCities(citiesRes?.data?.data);
      setLocations(locationsRes?.data?.data);
      setStates(statesRes?.data?.data); // Assuming `state` means states of India
      setBuilders(builderRes?.data?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchAmenities = async () => {
    try {
      const response = await axiosAPI.get("/api/properties/get-ammenities");
      const options = response.data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setAmenitiesOptions(options);
    } catch (error) {
      console.error("Failed to load amenities:", error);
    }
  };

  // Get All Media
  const getMedia = async () => {
    try {
      const response = await axiosAPI.get("/api/media");
      //   console.log(response.data.data);
      setMedia(response.data.data);

      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  // console.log("Uploaded Media",uploadedMedia)

  const selectMediaFileToSend = (
    index,
    thumbnail_url,
    media_url,
    media_type,
  ) => {
    // console.log("Selected Media:");

    if (selectedItems.includes(index)) {
      setSelectedItems([]);
      setSelectedPreview(null);
    } else {
      setSelectedItems([index]);
      setSelectedPreview({
        thumbnail_url,
        media_url,
        media_type,
      });

      // console.log("Selected Preview Set:", {
      //   thumbnail_url,
      //   media_url,
      //   media_type,
      // });
    }
  };

  useEffect(() => {
    fetchAmenities();
    getData();
    getMedia();
    fetchCategory();
  }, []);

  useEffect(() => {
    getProperty();
  }, [page]);

  useEffect(() => {
    if (shouldFetch) {
      getProperty();
      setShouldFetch(false); // reset trigger
    }
  }, [shouldFetch]);
  // useEffect(() => {
  //   console.log(formData);
  // }, [formData]);

  function changeGridHandler(type) {
    if (type === "rows") {
      setGridPosition("row");
    } else {
      setGridPosition("column");
    }
  }

  const parseAvailabilityValue = (value) => {
    if (typeof value === "boolean") return value;
    if (typeof value === "number") return value === 1;
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      return (
        normalized === "yes" || normalized === "true" || normalized === "1"
      );
    }
    return true;
  };

  // Handle Input Changes
  // const handleChange = (e) => {
  //   console.log(e.target.id, e.target.value);
  //   setFormData({ ...formData, [e.target.id]: e.target.value });
  // };

  const handleChange = (e) => {
    const { id, value } = e.target;

    const updatedForm = {
      ...formData,
      [id]: value,
    };
    // Auto-generate slug from propertyName
    if (id === "propertyName") {
      const slug = value
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "-") // Replace spaces with hyphen
        .replace(/[^\w\-]+/g, "") // Remove non-word chars
        .replace(/\-\-+/g, "-"); // Replace multiple hyphens

      updatedForm.propertySlug = slug;
    }

    if (id === "propertyUseType" && !value) {
      updatedForm.propertyDetails = [
        {
          srNo: "",
          area: "",
          floor: "",
          isAvailable: true,
        },
      ];
    }

    setFormData(updatedForm);
  };

  const handlePropertyDetailChange = (index, field, value) => {
    setFormData((prev) => {
      const updatedDetails = [...(prev.propertyDetails || [])];
      updatedDetails[index] = {
        ...updatedDetails[index],
        [field]: value,
      };
      return {
        ...prev,
        propertyDetails: updatedDetails,
      };
    });
  };

  const addPropertyDetailGroup = () => {
    setFormData((prev) => ({
      ...prev,
      propertyDetails: [
        ...(prev.propertyDetails || []),
        { srNo: "", area: "", floor: "", isAvailable: true },
      ],
    }));
  };

  const removePropertyDetailGroup = (index) => {
    setFormData((prev) => {
      const updatedDetails = [...(prev.propertyDetails || [])];
      updatedDetails.splice(index, 1);
      return {
        ...prev,
        propertyDetails:
          updatedDetails.length > 0
            ? updatedDetails
            : [{ srNo: "", area: "", floor: "", isAvailable: true }],
      };
    });
  };

  const handleBrochureChange = (e) => {
    const file = e.target.files?.[0] || null;

    const isPdf =
      file &&
      (file.type === "application/pdf" ||
        file.name.toLowerCase().endsWith(".pdf"));

    if (file && !isPdf) {
      window.notifyMessage(
        "Error",
        "Please upload a valid PDF file.",
        "danger",
      );
      e.target.value = "";
      return;
    }

    setFormData((prev) => ({
      ...prev,
      brochureFile: file,
    }));
  };

  const handleCheckboxChange = (id) => {
    setFormData((prevFormData) => {
      // SINGLE SELECT (Thumbnail)
      if (selectionType === "single") {
        return {
          ...prevFormData,
          thumbnail_media_id:
            prevFormData.thumbnail_media_id === id ? null : id,
        };
      }

      // MULTIPLE SELECT (Gallery Media)
      const alreadySelected = prevFormData.mediaIds.includes(id);

      const updatedMediaIds = alreadySelected
        ? prevFormData.mediaIds.filter((item) => item !== id) // deselect
        : [...prevFormData.mediaIds, id]; // select

      return {
        ...prevFormData,
        mediaIds: updatedMediaIds,
      };
    });
  };

  // Handle Submit (Add or Edit)
  const handleSubmit = async (e) => {
    e.preventDefault();

    // if (!formData.brochureFile && !isEditMode) {
    //   window.notifyMessage("Error", "Brochure PDF is required.", "danger");
    //   return;
    // }

    const shouldValidatePropertyDetails = Boolean(formData.propertyUseType);

    const normalizedPropertyDetails = (formData.propertyDetails || []).map(
      (item) => ({
        sr_no: item.srNo?.trim() || "",
        area: item.area?.toString().trim() || "",
        floor: item.floor?.toString().trim() || "",
        is_available: item.isAvailable ? "yes" : "no",
      }),
    );

    if (shouldValidatePropertyDetails) {
      const hasInvalidGroup = normalizedPropertyDetails.some(
        (item) => !item.sr_no || !item.area,
      );

      if (hasInvalidGroup) {
        window.notifyMessage(
          "Error",
          "Sr No and Area are required for each detail group.",
          "danger",
        );
        return;
      }
    }

    const payload = new FormData();
    payload.append("property_name", formData.propertyName || "");
    payload.append("property_type", formData.propertyType || "");
    // payload.append("property_use_type", formData.propertyUseType || "");
    payload.append("property_category", formData.propertyCategory || "");
    payload.append(
      "property_selling_price",
      formData.propertySellingPrice || "",
    );
    payload.append("property_address", formData.propertyAddress || "");
    payload.append("latitude", formData.latitude || "");
    payload.append("longitude", formData.longitude || "");
    payload.append("availability_status", formData.availabilityStatus || "");
    payload.append(
      "property_details",
      JSON.stringify(normalizedPropertyDetails),
    );
    payload.append("builder_id", formData.builder_id || "");
    payload.append("property_area", formData.propertyArea || "");
    payload.append("rooms", formData.rooms || "");
    payload.append("bedrooms", formData.bedrooms || "");
    payload.append("bathrooms", formData.bathrooms || "");
    payload.append("state", formData.state || "");
    payload.append("city", formData.city || "");
    payload.append("location", formData.location || "");
    payload.append("property_slug", formData.propertySlug || "");
    payload.append("thumbnail_media_id", formData.thumbnail_media_id || "");
    payload.append("heading", formData.heading || "");
    payload.append("description", formData.description || "");
    payload.append("ammenities", JSON.stringify(formData.ammenities || []));
    payload.append("media_ids", JSON.stringify(formData.mediaIds || []));
    payload.append("category_ids", JSON.stringify(formData.category_ids || []));

    const timelineWithDate = (formData.timeline || []).map((item, idx) => ({
      ...item,
      order_index: idx,
      updated_date: formData.timelineUpdatedDate || "Updated October 2026",
    }));
    const landmarksWithIndex = (formData.landmarks || []).map((item, idx) => ({
      ...item,
      order_index: idx,
    }));
    payload.append("construction_timeline", JSON.stringify(timelineWithDate));
    payload.append("location_landmarks", JSON.stringify(landmarksWithIndex));

    if (formData.brochureFile) {
      payload.append("file", formData.brochureFile);
    }

    // for (let pair of payload.entries()) {
    //   console.log(pair[0] + ": " + pair[1]);
    // }

    // setLoading(false);

    // return;

    setIsLoading(true);

    try {
      let response;
      if (isEditMode) {
        response = await axiosAPI.put(
          `/api/properties/update-property/${currentUserId}`,
          payload,
          { headers: { "Content-Type": "multipart/form-data" } },
        );
        window.notifyMessage(
          "Success",
          "Property updated successfully",
          "success",
        );
      } else {
        response = await axiosAPI.post(
          "/api/properties/add-property",
          payload,
          {
            headers: { "Content-Type": "multipart/form-data" },
          },
        );

        window.notifyMessage(
          "Success",
          "Property added successfully",
          "success",
        );
      }
      hideModal("newUserModal");
      getProperty(); // Reload page to reflect changes in the Property list
      removeFormData();
      setIsLoading(false);
      setIsEditMode(false);
      // window.location.reload(); // Reload page to reflect changes in the Property list
      closeModal();
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        window.notifyMessage("Error", error.response.data.message, "danger");
      } else {
        window.notifyMessage("Error", "There was an error!", "danger");
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Edit Modal Open

  const openEditModal = async (id) => {
    setIsEditMode(true);
    setCurrentUserId(id);

    const selectedProperty = properties.find((notif) => notif.id === id);

    // console.log("Selected property for editing:", selectedProperty);

    // Decide selectionType
    // Agar thumbnail_media_id bhi exist karta hai, modal open hone par
    // thumbnail select show karna ho toh single select set karo
    setSelectionType("multiple"); // Default for mediaIds
    // Agar aap thumbnail modal open kar rahe ho alag button se, toh setSelectionType("single") use karo

    const media_ids = selectedProperty?.media_ids || "";
    const mediaArray = media_ids ? media_ids.split(",").map(Number) : [];

    const thumbnailMediaId = selectedProperty?.thumbnail_media_id || null;

    const amenitiesString = selectedProperty?.amenities_id || "";
    const selectedAmenityIds = amenitiesString
      ? amenitiesString.split(",").map((id) => parseInt(id))
      : [];

    const preSelectedAmenities = amenitiesOptions.filter((opt) =>
      selectedAmenityIds.includes(opt.value),
    );
    setSelectedAmenities(preSelectedAmenities);

    setFormData({
      propertyName: selectedProperty.property_name,
      heading: selectedProperty.heading || "",
      description: selectedProperty.description || "",
      mediaUrl: selectedProperty.media_url,
      thumbnailUrl: selectedProperty.thumbnail_media_url,
      fileType: selectedProperty.media_file_type,
      propertyType: selectedProperty.property_type,
      // propertyUseType:
      //   selectedProperty.property_use_type || selectedProperty.type || "",
      propertyCategory: selectedProperty.property_category,
      propertySellingPrice: selectedProperty.property_selling_price,
      propertyAddress: selectedProperty.property_address,
      latitude: selectedProperty.latitude || selectedProperty.lat || "",
      longitude:
        selectedProperty.longitude ||
        selectedProperty.long ||
        selectedProperty.lng ||
        "",
      brochureFile: selectedProperty.broucher_url  || null,
      existingBrochure:
        selectedProperty.brochure || selectedProperty.brochure_url || "",
      availabilityStatus:
        selectedProperty.availability_status || selectedProperty.status || "",
      propertyDetails: (() => {
        const rawDetails =
          selectedProperty.property_details || selectedProperty.details || [];

        let parsedDetails = [];
        if (Array.isArray(rawDetails)) {
          parsedDetails = rawDetails;
        } else if (typeof rawDetails === "string") {
          try {
            parsedDetails = JSON.parse(rawDetails);
          } catch {
            parsedDetails = [];
          }
        }

        if (!Array.isArray(parsedDetails) || parsedDetails.length === 0) {
          parsedDetails = [
            {
              sr_no:
                selectedProperty.sr_no ||
                selectedProperty.shop_unit_number ||
                selectedProperty.unit_number ||
                "",
              area:
                selectedProperty.commercial_area_sq_ft ||
                selectedProperty.area_sq_ft ||
                "",
              floor: selectedProperty.floor || "",
            },
          ];
        }

        return parsedDetails.map((item) => ({
          srNo: item.sr_no || item.srNo || "",
          area: item.area || item.commercial_area_sq_ft || "",
          floor: item.floor || "",
          isAvailable:
            typeof item.is_available !== "undefined"
              ? parseAvailabilityValue(item.is_available)
              : typeof item.isAvailable !== "undefined"
                ? parseAvailabilityValue(item.isAvailable)
                : true,
        }));
      })(),
      builder_id: selectedProperty.builder_id,
      propertyArea: selectedProperty.property_area,
      rooms: selectedProperty.rooms,
      bedrooms: selectedProperty.bedrooms,
      bathrooms: selectedProperty.bathrooms,
      state: selectedProperty.state,
      city: selectedProperty.city,
      location: selectedProperty.location,
      ammenities: selectedAmenityIds,
      propertySlug: selectedProperty.slug,
      mediaIds: mediaArray,
      thumbnail_media_id: thumbnailMediaId, //  Thumbnail store
      category_ids: selectedProperty.categories_ids
        ? selectedProperty.categories_ids.split(",").map(Number)
        : [],
      timeline: [],
      landmarks: [],
      timelineUpdatedDate: "Updated October 2026",
    });

    try {
      const extraRes = await axiosAPI.get(`/api/properties/timeline-landmarks/${id}`);
      if (extraRes?.data?.success) {
        const t = extraRes.data.timeline || [];
        const l = extraRes.data.landmarks || [];
        setFormData((prev) => ({
          ...prev,
          timeline: t,
          landmarks: l,
          timelineUpdatedDate: t[0]?.updated_date || "Updated October 2026",
        }));
      }
    } catch (e) {
      console.error("Error fetching timeline & landmarks:", e);
    }

    const modal = new window.bootstrap.Modal(
      document.getElementById("newUserModal"),
    );
    modal.show();
  };

  const handleDelete = async (id) => {
    // console.log(id);
    const isConfirmed = window.confirm("Are you sure you want to delete this?");
    if (!isConfirmed) return;

    try {
      const response = await axiosAPI.delete(
        `/api/properties/delete-property/${id}`,
      );
      window.notifyMessage("Success", "Deleted successfully", "success");
      getProperty();
    } catch (error) {
      console.error("Error deleting:", error);
      window.notifyMessage(
        "Error",
        "An error occurred while deleting.",
        "danger",
      );
    }
  };

  // Close Modal
  const closeModal = () => {
    setIsEditMode(false);
    removeFormData();
    setCurrentUserId(null);
  };

  // Helper functions to manage modal visibility
  function hideModal(id) {
    const modal_el = document.querySelector("#" + id);
    const modal_obj = window.bootstrap.Modal.getInstance(modal_el);

    if (modal_obj == null) {
      return;
    }

    modal_obj.hide();
  }

  function showModal(id) {
    const modal_el = document.querySelector("#" + id);
    let modal_obj = window.bootstrap.Modal.getInstance(modal_el);

    if (modal_obj == null) {
      modal_obj = new window.bootstrap.Modal(modal_el, {
        backdrop: "static",
      });
    }

    modal_obj.show();
  }

  function openMediaLibraryModal() {
    showModal("customModal");
  }

  function handleMediaSumbit() {
    // console.log("Media Ids", formData.mediaIds);
    hideModal("customModal");
  }

  const openAddModal = () => {
    showModal("newUserModal");
  };

  // console.log("Form Data:", formData);

  return (
    <div className="container">
      <div className="page-inner">
        <div className="d-flex justify-content-end align-items-end flex-column flex-md-row">
          <div>
            <button
              type="button"
              className="btn btn-dark btn-round mb-4"
              onClick={() => openAddModal()}
            >
              Add Property
            </button>
          </div>
        </div>

        {/* Modal */}
        <div
          className="modal fade"
          id="newUserModal"
          tabIndex="-1"
          aria-labelledby="newUserModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="newUserModalLabel">
                  {isEditMode ? "Edit Property" : "Add Property"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                ></button>
              </div>

              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  {/* Property Name (Input Field) */}
                  <div className="row">
                    <div className="mb-3 col-md-6 col-sm-12">
                      <label htmlFor="propertyName" className="form-label">
                        Property Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="propertyName"
                        placeholder="Enter property name"
                        value={formData.propertyName}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3 col-md-6 col-sm-12">
                      <label htmlFor="propertyAddress" className="form-label">
                        Address
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="propertyAddress"
                        placeholder="Enter property address"
                        value={formData.propertyAddress}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="propertyCategory" className="form-label">
                        Select Category
                      </label>
                      <select
                        id="propertyCategory"
                        className="form-select"
                        value={formData.propertyCategory}
                        onChange={handleChange}
                      >
                        <option value="">-- Select Category --</option>
                        <option value="villa">Villa</option>
                        <option value="apartment">Apartment</option>
                        <option value="shop_showroom">Shop showroom</option>
                        <option value="shop_office">Shop office</option>
                        <option value="opd_clinic">Opd clinic</option>
                        <option value="commercial">Commercial</option>
                        <option value="residential">Residential</option>
                        <option value="land">Land</option>
                        <option value="industrial">Industrial</option>
                        <option value="mixed_use">Mixed Use</option>
                      </select>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="propertyType" className="form-label">
                        Select Property Type
                      </label>
                      <select
                        id="propertyType"
                        className="form-select"
                        value={formData.propertyType}
                        onChange={handleChange}
                      >
                        <option value="">-- Select Property Type --</option>
                        <option value="for_rent">Rent</option>
                        <option value="for_sale">Sale</option>
                      </select>
                    </div>
                    {/* <div className="col-md-6 mb-3">
                      <label htmlFor="propertyUseType" className="form-label">
                        Type
                      </label>
                      <select
                        id="propertyUseType"
                        className="form-select"
                        value={formData.propertyUseType}
                        onChange={handleChange}
                      >
                        <option value="">-- Select Type --</option>
                        <option value="commercial">Commercial</option>
                        <option value="residential">Residential</option>
                        <option value="land">Land</option>
                        <option value="industrial">Industrial</option>
                        <option value="mixed_use">Mixed Use</option>
                      </select>
                    </div> */}
                    <div className="col-md-6 mb-3">
                      <label
                        htmlFor="availabilityStatus"
                        className="form-label"
                      >
                        Status
                      </label>
                      <select
                        id="availabilityStatus"
                        className="form-select"
                        value={formData.availabilityStatus}
                        onChange={handleChange}
                      >
                        <option value="">-- Select Status --</option>
                        <option value="available">Available</option>
                        <option value="sold">Sold</option>
                        <option value="rented">Rented</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Select Amenities</label>
                      <Select
                        isMulti
                        options={amenitiesOptions}
                        value={selectedAmenities}
                        onChange={handleAmenitiesChange}
                        placeholder="Select amenities"
                        classNamePrefix="select"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label htmlFor="latitude" className="form-label">
                        Latitude
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="latitude"
                        placeholder="Enter latitude"
                        value={formData.latitude}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <label htmlFor="longitude" className="form-label">
                        Longitude
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="longitude"
                        placeholder="Enter longitude"
                        value={formData.longitude}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <label htmlFor="brochureFile" className="form-label">
                        Brochure (PDF)
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        id="brochureFile"
                        accept="application/pdf"
                        onChange={handleBrochureChange}
                        // required={!isEditMode}
                      />
                      {formData.brochureFile && (
                        <small className="text-success d-block mt-1">
                          Selected: {formData.brochureFile.name}
                        </small>
                      )}
                      {!formData.brochureFile && formData.existingBrochure && (
                        <small className="d-block mt-1">
                          Current:
                          <a
                            href={formData.existingBrochure}
                            target="_blank"
                            rel="noreferrer"
                            className="ms-1"
                          >
                            View brochure
                          </a>
                        </small>
                      )}
                    </div>
                  </div>

                  {Boolean(formData.propertyCategory) && (
                    <div className="mb-3 border rounded p-3">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="mb-0">Property Availability</h6>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-primary"
                          onClick={addPropertyDetailGroup}
                        >
                          Add More
                        </button>
                      </div>

                      {(formData.propertyDetails || []).map((detail, index) => (
                        <div className="row align-items-end" key={index}>
                          <div className="col-md-3 mb-3">
                            <label className="form-label">Sr No</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Sr No (Plot-A, Plot-B, etc.)"
                              value={detail.srNo}
                              onChange={(e) =>
                                handlePropertyDetailChange(
                                  index,
                                  "srNo",
                                  e.target.value,
                                )
                              }
                              required
                            />
                          </div>

                          <div className="col-md-3 mb-3">
                            <label className="form-label">Area</label>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter area in sq ft"
                              value={detail.area}
                              onChange={(e) =>
                                handlePropertyDetailChange(
                                  index,
                                  "area",
                                  e.target.value,
                                )
                              }
                              required
                            />
                          </div>

                          <div className="col-md-3 mb-3">
                            <label className="form-label">
                              Floor (Optional)
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter floor"
                              value={detail.floor}
                              onChange={(e) =>
                                handlePropertyDetailChange(
                                  index,
                                  "floor",
                                  e.target.value,
                                )
                              }
                            />
                          </div>

                          <div className="col-md-2 mb-3">
                            <label className="form-label d-block">
                              Available
                            </label>
                            <div className="form-check form-switch mt-2">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id={`detailAvailable-${index}`}
                                checked={Boolean(detail.isAvailable)}
                                onChange={(e) =>
                                  handlePropertyDetailChange(
                                    index,
                                    "isAvailable",
                                    e.target.checked,
                                  )
                                }
                              />
                            </div>
                          </div>

                          <div className="col-md-1 mb-3">
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-danger w-100"
                              onClick={() => removePropertyDetailGroup(index)}
                              disabled={
                                (formData.propertyDetails || []).length === 1
                              }
                              title="Remove"
                            >
                              X
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  <div className="mb-3">
                    <label htmlFor="category_ids" className="form-label">
                      Categories
                    </label>
                    <Select
                      id="category_ids"
                      options={categoryOptions}
                      isMulti
                      //  Ensure category_ids is always an array
                      value={categoryOptions.filter((option) =>
                        (formData.category_ids || []).includes(option.value),
                      )}
                      onChange={(selectedOptions) => {
                        // React-Select already gives all selected values
                        const newIds =
                          selectedOptions?.map((opt) => opt.value) || [];
                        setFormData({
                          ...formData,
                          category_ids: newIds, // replace with new selection
                        });
                      }}
                      placeholder="Select Category"
                      isClearable
                    />
                  </div>

                  <div className="row">
                    <div className="mb-3 col-md-4 col-sm-12">
                      <label htmlFor="propertyArea" className="form-label">
                        Area in (sq ft)
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="propertyArea"
                        placeholder="Enter area in sq ft"
                        value={formData.propertyArea}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3 col-md-4 col-sm-12">
                      <label
                        htmlFor="propertySellingPrice"
                        className="form-label"
                      >
                        Property Selling Amount
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="propertySellingPrice"
                        placeholder="Enter property selling amount"
                        value={formData.propertySellingPrice}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3 col-md-4 col-sm-12">
                      <label htmlFor="propertySlug" className="form-label">
                        Property Slug
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="propertySlug"
                        placeholder="Enter property slug"
                        value={formData.propertySlug}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label htmlFor="state" className="form-label">
                        Select State
                      </label>
                      <select
                        id="state"
                        className="form-select"
                        value={formData.state}
                        onChange={handleChange}
                      >
                        <option value="">-- Select State --</option>
                        {states.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label htmlFor="city" className="form-label">
                        Select City
                      </label>
                      <select
                        id="city"
                        className="form-select"
                        value={formData.city}
                        onChange={handleChange}
                        // disabled={!selectedState} // Disable until state is selected
                      >
                        <option value="">-- Select City --</option>
                        {cities.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label htmlFor="location" className="form-label">
                        Select Location
                      </label>
                      <select
                        id="location"
                        className="form-select"
                        value={formData.location}
                        onChange={handleChange}
                        // disabled={!selectedCity} // Disable until city is selected
                      >
                        <option value="">-- Select Location --</option>
                        {locations.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    {/* Rooms */}
                    <div className="col-md-4 mb-3">
                      <label htmlFor="rooms" className="form-label">
                        Select Rooms
                      </label>
                      <select
                        id="rooms"
                        className="form-select"
                        value={formData.rooms}
                        onChange={handleChange}
                      >
                        <option value="">-- Select Rooms --</option>
                        {[...Array(10)].map((_, index) => (
                          <option key={index + 1} value={index + 1}>
                            {index + 1}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Bedrooms */}
                    <div className="col-md-4 mb-3">
                      <label htmlFor="bedrooms" className="form-label">
                        Select Bedrooms
                      </label>
                      <select
                        id="bedrooms"
                        className="form-select"
                        value={formData.bedrooms}
                        onChange={handleChange}
                      >
                        <option value="">-- Select Bedrooms --</option>
                        {[...Array(10)].map((_, index) => (
                          <option key={index + 1} value={index + 1}>
                            {index + 1}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Bathrooms */}
                    <div className="col-md-4 mb-3">
                      <label htmlFor="bathrooms" className="form-label">
                        Select Bathrooms
                      </label>
                      <select
                        id="bathrooms"
                        className="form-select"
                        value={formData.bathrooms}
                        onChange={handleChange}
                      >
                        <option value="">-- Select Bathrooms --</option>
                        {[...Array(10)].map((_, index) => (
                          <option key={index + 1} value={index + 1}>
                            {index + 1}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="mb-3 col-md-4 col-sm-12">
                      <label htmlFor="builder_id" className="form-label">
                        Select Builder
                      </label>
                      <select
                        className="form-select"
                        id="builder_id"
                        value={formData.builder_id}
                        onChange={handleChange}
                        name="builder_id"
                      >
                        <option value="">-- Select a builder --</option>
                        {builders.map((builder) => (
                          <option key={builder.id} value={builder.id}>
                            {builder.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <hr />

                  <div className="row">
                    <div className="mb-3 col-md-12 col-sm-12">
                      <label htmlFor="heading" className="form-label">
                        Heading
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="heading"
                        placeholder="Enter property heading"
                        value={formData.heading}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3 col-md-12 col-sm-12">
                      <label htmlFor="description" className="form-label">
                        Description
                      </label>
                      <textarea
                        className="form-control"
                        id="description"
                        placeholder="Enter property description"
                        value={formData.description}
                        onChange={handleChange}
                        rows={4} // optional: height control
                      />
                    </div>
                  </div>

                  {/* Construction Progress Timeline Tracker */}
                  <div className="card border rounded-3 mb-4 shadow-none bg-light">
                    <div className="card-header bg-white d-flex justify-content-between align-items-center flex-wrap gap-2 py-2 px-3">
                      <div>
                        <h6 className="fw-bold mb-0 text-dark">
                          <i className="fas fa-hammer text-primary me-2"></i>
                          Construction Progress Timeline
                        </h6>
                        <small className="text-muted">Verified on-site construction milestones</small>
                      </div>
                      <div className="d-flex gap-2 align-items-center">
                        <button
                          type="button"
                          className="btn btn-outline-primary btn-sm rounded-pill px-3"
                          onClick={handleLoadDefaultTimeline}
                          title="Auto-fill standard 5 construction milestones"
                        >
                          <i className="fas fa-magic me-1"></i> Load Default Stages
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary btn-sm rounded-pill px-3"
                          onClick={handleAddTimelineStage}
                        >
                          <i className="fas fa-plus me-1"></i> Add Stage
                        </button>
                      </div>
                    </div>
                    <div className="card-body p-3">
                      <div className="row mb-3">
                        <div className="col-md-6 col-sm-12">
                          <label className="form-label fw-bold small">Timeline Update Label (e.g. Updated October 2026)</label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="e.g. Updated October 2026"
                            value={formData.timelineUpdatedDate || ""}
                            onChange={(e) =>
                              setFormData({ ...formData, timelineUpdatedDate: e.target.value })
                            }
                          />
                        </div>
                      </div>

                      {(!formData.timeline || formData.timeline.length === 0) ? (
                        <div className="text-center py-4 bg-white rounded-3 border border-dashed">
                          <p className="text-muted mb-2 small">No construction milestones added yet.</p>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-primary rounded-pill px-3"
                            onClick={handleLoadDefaultTimeline}
                          >
                            <i className="fas fa-magic me-1"></i> Click to Load Standard 5 Stages
                          </button>
                        </div>
                      ) : (
                        <div className="d-flex flex-column gap-3">
                          {formData.timeline.map((stage, idx) => (
                            <div key={idx} className="p-3 bg-white rounded-3 border shadow-sm position-relative">
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <span className="badge bg-secondary">Milestone #{idx + 1}</span>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-danger py-0 px-2"
                                  onClick={() => handleRemoveTimelineStage(idx)}
                                  title="Remove milestone"
                                >
                                  <i className="fas fa-trash-alt"></i>
                                </button>
                              </div>
                              <div className="row g-2">
                                <div className="col-md-7">
                                  <label className="form-label small mb-1 fw-semibold">Stage Title</label>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="e.g. Land Acquisition & Title Due Diligence"
                                    value={stage.title || ""}
                                    onChange={(e) =>
                                      handleUpdateTimelineStage(idx, "title", e.target.value)
                                    }
                                  />
                                </div>
                                <div className="col-md-5">
                                  <label className="form-label small mb-1 fw-semibold">Stage Status</label>
                                  <select
                                    className={`form-select form-select-sm fw-bold ${
                                      stage.status === "completed"
                                        ? "text-success border-success"
                                        : stage.status === "current"
                                        ? "text-danger border-danger"
                                        : "text-muted"
                                    }`}
                                    value={stage.status || "pending"}
                                    onChange={(e) =>
                                      handleUpdateTimelineStage(idx, "status", e.target.value)
                                    }
                                  >
                                    <option value="completed">✓ Completed</option>
                                    <option value="current">● Current Stage (In Progress)</option>
                                    <option value="pending">○ Pending / Upcoming</option>
                                  </select>
                                </div>
                                <div className="col-12 mt-2">
                                  <label className="form-label small mb-1 fw-semibold">Stage Description</label>
                                  <textarea
                                    className="form-control form-control-sm"
                                    rows={2}
                                    placeholder="e.g. Clear 30-year title deeds, ADA layout sanction, and UP RERA registration obtained."
                                    value={stage.description || ""}
                                    onChange={(e) =>
                                      handleUpdateTimelineStage(idx, "description", e.target.value)
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Location Intelligence & Landmark Distances */}
                  <div className="card border rounded-3 mb-4 shadow-none bg-light">
                    <div className="card-header bg-white d-flex justify-content-between align-items-center flex-wrap gap-2 py-2 px-3">
                      <div>
                        <h6 className="fw-bold mb-0 text-dark">
                          <i className="fas fa-map-marker-alt text-danger me-2"></i>
                          Location Intelligence & Landmark Distances
                        </h6>
                        <small className="text-muted">Key transit hubs, highways, railway, schools, and drive times</small>
                      </div>
                      <div className="d-flex gap-2 align-items-center">
                        <button
                          type="button"
                          className="btn btn-outline-primary btn-sm rounded-pill px-3"
                          onClick={handleLoadDefaultLandmarks}
                          title="Auto-fill standard landmark distances"
                        >
                          <i className="fas fa-magic me-1"></i> Load Default Landmarks
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary btn-sm rounded-pill px-3"
                          onClick={handleAddLandmark}
                        >
                          <i className="fas fa-plus me-1"></i> Add Landmark
                        </button>
                      </div>
                    </div>
                    <div className="card-body p-3">
                      {(!formData.landmarks || formData.landmarks.length === 0) ? (
                        <div className="text-center py-4 bg-white rounded-3 border border-dashed">
                          <p className="text-muted mb-2 small">No landmark distances added yet.</p>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-primary rounded-pill px-3"
                            onClick={handleLoadDefaultLandmarks}
                          >
                            <i className="fas fa-magic me-1"></i> Click to Load Standard Landmarks
                          </button>
                        </div>
                      ) : (
                        <div className="table-responsive bg-white rounded border shadow-sm">
                          <table className="table table-sm table-hover align-middle mb-0">
                            <thead className="table-light">
                              <tr>
                                <th style={{ minWidth: "220px" }}>Key Landmark / Transit Point</th>
                                <th style={{ minWidth: "150px" }}>Category</th>
                                <th style={{ minWidth: "100px" }}>Distance</th>
                                <th style={{ minWidth: "100px" }}>Drive Time</th>
                                <th style={{ width: "40px" }}></th>
                              </tr>
                            </thead>
                            <tbody>
                              {formData.landmarks.map((lm, idx) => (
                                <tr key={idx}>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      placeholder="e.g. Agra-Lucknow Expressway"
                                      value={lm.landmark_name || ""}
                                      onChange={(e) =>
                                        handleUpdateLandmark(idx, "landmark_name", e.target.value)
                                      }
                                    />
                                  </td>
                                  <td>
                                    <select
                                      className="form-select form-select-sm"
                                      value={lm.category || "Expressway"}
                                      onChange={(e) =>
                                        handleUpdateLandmark(idx, "category", e.target.value)
                                      }
                                    >
                                      <option value="Expressway">Expressway</option>
                                      <option value="National Highway">National Highway</option>
                                      <option value="Railway">Railway</option>
                                      <option value="Metro Station">Metro Station</option>
                                      <option value="Airport Corridor">Airport Corridor</option>
                                      <option value="School">School / College</option>
                                      <option value="Hospital">Hospital</option>
                                      <option value="Commercial Hub">Commercial Hub</option>
                                      <option value="Shopping Mall">Shopping Mall</option>
                                      <option value="Bus Stand">Bus Stand</option>
                                    </select>
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      placeholder="e.g. 4.2 km"
                                      value={lm.distance || ""}
                                      onChange={(e) =>
                                        handleUpdateLandmark(idx, "distance", e.target.value)
                                      }
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      placeholder="e.g. 7 Mins"
                                      value={lm.drive_time || ""}
                                      onChange={(e) =>
                                        handleUpdateLandmark(idx, "drive_time", e.target.value)
                                      }
                                    />
                                  </td>
                                  <td>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-danger py-0 px-2"
                                      onClick={() => handleRemoveLandmark(idx)}
                                      title="Remove landmark"
                                    >
                                      <i className="fas fa-trash-alt"></i>
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="mb-3 d-flex flex-column gap-4">
                    {/* Media */}
                    <div className="d-flex-col align-items-center gap-3">
                      <h6 className="mb-0">
                        Total Media selected: {formData.mediaIds?.length || 0}
                      </h6>
                      <button
                        className="btn btn-secondary btn-border btn-round btn-sm"
                        type="button"
                        onClick={() => {
                          setSelectionType("multiple");
                          openMediaLibraryModal();
                        }}
                      >
                        <i className="fas fa-photo-video me-1"></i>
                        Select Media From Gallery
                      </button>
                    </div>

                    {/* Thumbnail */}
                    <div className="d-flex-col align-items-center gap-3">
                      <h6 className="mb-0">
                        Total Thumbnail selected:{" "}
                        {formData.thumbnail_media_id ? 1 : 0}
                      </h6>
                      <button
                        className="btn btn-secondary btn-border btn-round btn-sm"
                        type="button"
                        onClick={() => {
                          setSelectionType("single");
                          openMediaLibraryModal();
                        }}
                      >
                        <i className="fas fa-photo-video me-1"></i>
                        Select Thumbnail From Gallery
                      </button>
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="submit"
                      className="btn btn-primary  btn-sm"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <FaSpinner className="spinner" spin />
                      ) : isEditMode ? (
                        "Update Property"
                      ) : (
                        "Add Property"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="customModal"
          tabIndex="-1"
          aria-labelledby="customModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog  modal-dialog-centered modal-lg modal-dialog-scrollable">
            <div className="modal-content">
              {/* Modal Header */}
              <div className="modal-header">
                <h5 className="modal-title" id="customModalLabel">
                  {mediaType === "video" ? "Media Library" : "Media Library"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              {/* Modal Body */}
              <div className="modal-body">
                {/* Top Bar */}
                <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                  <input
                    type="text"
                    className="form-control w-50"
                    placeholder="Search media..."
                    // onChange={(e) => setSearch(e.target.value)}
                  />
                  <div className="d-flex align-items-center gap-2">
                    <select className="form-select">
                      <option value="recent">Sort by: Recent</option>
                      <option value="name">Sort by: Name</option>
                    </select>
                    <button
                      onClick={() => changeGridHandler("rows")}
                      className="btn btn-outline-secondary"
                    >
                      <i className="fas fa-th-large"></i>
                    </button>
                    <button
                      onClick={() => changeGridHandler("column")}
                      className="btn btn-outline-secondary"
                    >
                      <i className="fas fa-list"></i>
                    </button>
                  </div>
                </div>
                {/* Upload Section */}
                <div className="media-grid row">
                  {media?.map((item, index) => {
                    // const isChecked = formData.mediaIds?.includes(item.id);
                    const isChecked =
                      selectionType === "single"
                        ? formData.thumbnail_media_id == item.id
                        : formData.mediaIds?.includes(item.id);

                    return (
                      <div className="col-md-3 mb-4" key={index}>
                        <div className="card h-100">
                          <div className="position-relative">
                            {/* Show image or video based on type */}
                            {item.media_type === "video" ? (
                              <video
                                src={item.media_url || item?.file_path}
                                controls
                                autoPlay
                                loop
                                muted
                                className="card-img-top"
                                style={{ height: "160px", objectFit: "cover" }}
                              />
                            ) : (
                              <img
                                src={
                                  item.media_url ||
                                  item?.thumbnail_url ||
                                  item?.file_path
                                }
                                alt={item.media_name}
                                className="card-img-top"
                                style={{ height: "160px", objectFit: "cover" }}
                              />
                            )}

                            {/* Checkbox */}
                            <div className="position-absolute top-0 end-0 p-2">
                              <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={() => handleCheckboxChange(item.id)}
                              />
                            </div>
                          </div>

                          <div className="card-body p-2 text-center">
                            <small className="text-muted">
                              {item.media_name}
                            </small>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                {/* Modal Inside Contain Image and Video */}
                {/* <div className="row g-3"> */}
                <div
                  className={`${
                    gridPosition === "row" ? "row" : "col gap-2"
                  } g-3`}
                >
                  {uploadedMedia
                    .filter((item) => item.media_type === mediaType)
                    .map((item, index) => {
                      const isSelected = selectedItems.includes(index);
                      return (
                        <div className="col-6 col-md-3" key={index}>
                          <div
                            className="border rounded p-2 text-center position-relative"
                            style={{
                              cursor: "pointer",
                              maxWidth: "180px",
                              height: "130px",
                              margin: "0 auto",
                            }}
                            onClick={() =>
                              selectMediaFileToSend(
                                index,
                                item.thumbnail_url,
                                item.media_url,
                                item.media_type,
                              )
                            }
                          >
                            {/*  Fixed Selection Box */}
                            <div
                              style={{
                                position: "absolute",
                                top: "5px",
                                left: "5px",
                                width: "20px",
                                height: "20px",
                                backgroundColor: "white",
                                border: "2px solid #999",
                                borderRadius: "4px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                zIndex: 2,
                                fontSize: "14px",
                                fontWeight: "bold",
                              }}
                            >
                              {isSelected ? "" : ""}
                            </div>

                            {item.media_type === "image" ? (
                              <img
                                src={item.thumbnail_url}
                                alt={`media-${index}`}
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  objectFit: "contain", // contain or contain based on your need
                                  borderRadius: "4px",
                                }}
                              />
                            ) : (
                              <video
                                src={item.media_url}
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  objectFit: "contain",
                                  borderRadius: "4px",
                                }}
                                muted
                                loop
                                playsInline
                              />
                            )}
                          </div>
                        </div>
                      );
                    })}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="btn btn-primary"
                    // data-bs-toggle="modal"
                    // data-bs-target="#customModal"
                    onClick={handleMediaSumbit}
                    // disabled={!selectedPreview}
                  >
                    Select Media From Library
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Properties Table */}
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <div className="row align-items-center">
                  {/* Title Section */}
                  <div className="col-12 col-md-6 mb-2 mb-md-0">
                    <h4 className="card-title">
                      All Properties ({properties.length})
                    </h4>
                  </div>

                  {/* Filter Controls */}
                  <div className="col-12 col-md-6">
                    <div className="d-flex flex-column flex-sm-row justify-content-md-end align-items-stretch gap-2">
                      {/* Search Input */}
                      <div
                        className="position-relative "
                        style={{ width: "310px" }}
                      >
                        <input
                          className="form-control shadow-sm px-3 py-2 border-2 w-100"
                          type="text"
                          placeholder="Enter property name or builder name or price..."
                          style={{ paddingRight: "110px" }}
                          value={filters.search}
                          onChange={(e) =>
                            handleFilterChange("search", e.target.value)
                          }
                        />
                      </div>
                      <div>
                        {/* Filter Button */}
                        <button
                          onClick={() => {
                            if (filters.search) {
                              setPage(1);
                              getProperty();
                            } else {
                              alert("Please search something...");
                            }
                          }}
                          className="btn btn-primary rounded-pill px-4 w-100 w-sm-auto"
                        >
                          Filter
                        </button>
                      </div>

                      {/* Reset Button */}
                      <button
                        className="btn btn-icon btn-round btn-dark py-3 px-3"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Reset Filters"
                        onClick={handleResetFilters}
                      >
                        <i className="fas fa-sync-alt"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Property Name</th>
                        <th>Media Type</th>
                        <th>Thumbnail</th>
                        {/* <th>Media Url</th> */}
                        <th>Property Selling price</th>
                        <th>Created At</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="4" className="text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : properties.length === 0 ? (
                        <tr>
                          <td colSpan="6" className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      ) : (
                        properties.map((property) => {
                          const formattedDate = new Date(
                            property.created_at,
                          ).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          });

                          // Check if the message length is greater than 50 characters
                          //   const truncatedMessage =
                          //     property.thumbnailUrl.length > 50
                          //       ? property.thumbnailUrl.slice(0, 50) + "..."
                          //       : property.thumbnailUrl;

                          return (
                            <tr key={property.id}>
                              <td>{property.property_name}</td>
                              <td>{property.media_file_type}</td>

                              <td>
                                <img
                                  src={
                                    property.thumbnail_media_url && property.thumbnail_media_url !== "0"
                                      ? property.thumbnail_media_url
                                      : "https://cdn.balajipropertiesarcade.com/assets/images/builder-logo.png"
                                  }
                                  alt="Thumbnail"
                                  style={{
                                    width: "90px",
                                    height: "60px",
                                    objectFit: "cover",
                                    borderRadius: "6px",
                                    backgroundColor: "#f8f9fa",
                                    border: "1px solid #dee2e6",
                                  }}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src =
                                      "https://cdn.balajipropertiesarcade.com/assets/images/builder-logo.png";
                                  }}
                                />
                              </td>
                              <td>
                                {property.property_selling_price
                                  ? `₹ ${property.property_selling_price}`
                                  : ""}
                              </td>

                              <td>{formattedDate}</td>
                              <td>
                                <a
                                  href={property.media_url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="custom-link btn btn-icon btn-round btn-dark btn-sm border me-2"
                                >
                                  <FaLink size={12} />
                                </a>
                                <button
                                  className="btn btn-icon btn-round btn-info btn-sm me-2 text-white"
                                  title="Manage Construction Timeline & Landmarks"
                                  onClick={() => openTimelineLandmarksModal(property)}
                                >
                                  <i className="fas fa-tasks"></i>
                                </button>
                                <button
                                  className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                  onClick={() => openEditModal(property.id)}
                                >
                                  <i className="fas fa-edit"></i>
                                </button>
                                <button
                                  className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                  onClick={() => handleDelete(property.id)}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <Pagination totalPages={totalPages} setPage={setPage} page={page} />
          </div>
        </div>

        {/* Standalone Quick Timeline & Landmarks Modal */}
        {timelineModalOpen && (
          <div
            className="modal fade show d-block"
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0,0,0,0.6)", zIndex: 100050 }}
          >
            <div className="modal-dialog modal-xl modal-dialog-scrollable">
              <div className="modal-content border-0 shadow-lg rounded-4">
                <div className="modal-header bg-dark text-white rounded-top-4 py-3">
                  <div>
                    <h5 className="modal-title fw-bold mb-0">
                      <i className="fas fa-tasks text-warning me-2"></i>
                      Manage Timeline & Landmark Distances
                    </h5>
                    <small className="text-light opacity-75">
                      Property: <strong>{selectedPropertyForExtras?.property_name}</strong>
                    </small>
                  </div>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setTimelineModalOpen(false)}
                  ></button>
                </div>

                <div className="modal-body p-4 bg-light">
                  {/* Nav Tabs */}
                  <ul className="nav nav-pills mb-4 gap-2 border-bottom pb-3">
                    <li className="nav-item">
                      <button
                        className={`nav-link fw-bold px-4 rounded-pill ${
                          extrasActiveTab === "timeline" ? "active btn-primary" : "bg-white text-dark border"
                        }`}
                        onClick={() => setExtrasActiveTab("timeline")}
                      >
                        <i className="fas fa-hammer me-2"></i>
                        Construction Timeline Tracker
                        <span className="badge bg-secondary ms-2">{extraTimeline.length}</span>
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link fw-bold px-4 rounded-pill ${
                          extrasActiveTab === "landmarks" ? "active btn-primary" : "bg-white text-dark border"
                        }`}
                        onClick={() => setExtrasActiveTab("landmarks")}
                      >
                        <i className="fas fa-map-marker-alt me-2"></i>
                        Landmarks & Distances
                        <span className="badge bg-secondary ms-2">{extraLandmarks.length}</span>
                      </button>
                    </li>
                  </ul>

                  {/* Tab 1: Construction Timeline */}
                  {extrasActiveTab === "timeline" && (
                    <div className="card border-0 shadow-sm rounded-3 p-3 bg-white">
                      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                        <div className="d-flex align-items-center gap-2">
                          <label className="form-label mb-0 small fw-bold text-muted">Update Label:</label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            style={{ maxWidth: "250px" }}
                            value={extraUpdatedDate}
                            placeholder="e.g. Updated October 2026"
                            onChange={(e) => setExtraUpdatedDate(e.target.value)}
                          />
                        </div>
                        <div className="d-flex gap-2">
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-primary rounded-pill px-3"
                            onClick={() => setExtraTimeline(DEFAULT_TIMELINE_TEMPLATE)}
                          >
                            <i className="fas fa-magic me-1"></i> Reset to 5 Default Stages
                          </button>
                          <button
                            type="button"
                            className="btn btn-sm btn-primary rounded-pill px-3"
                            onClick={() =>
                              setExtraTimeline([
                                ...extraTimeline,
                                { title: "", description: "", status: "pending" },
                              ])
                            }
                          >
                            <i className="fas fa-plus me-1"></i> Add Stage
                          </button>
                        </div>
                      </div>

                      <div className="d-flex flex-column gap-3">
                        {extraTimeline.map((stage, idx) => (
                          <div key={idx} className="p-3 bg-light rounded-3 border">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <span className="badge bg-dark">Stage #{idx + 1}</span>
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-danger py-0 px-2"
                                onClick={() => {
                                  const updated = [...extraTimeline];
                                  updated.splice(idx, 1);
                                  setExtraTimeline(updated);
                                }}
                              >
                                <i className="fas fa-trash-alt"></i>
                              </button>
                            </div>
                            <div className="row g-2">
                              <div className="col-md-7">
                                <label className="form-label small fw-semibold mb-1">Milestone Title</label>
                                <input
                                  type="text"
                                  className="form-control form-control-sm bg-white"
                                  placeholder="e.g. Superstructure & Slab Casting"
                                  value={stage.title || ""}
                                  onChange={(e) => {
                                    const updated = [...extraTimeline];
                                    updated[idx] = { ...updated[idx], title: e.target.value };
                                    setExtraTimeline(updated);
                                  }}
                                />
                              </div>
                              <div className="col-md-5">
                                <label className="form-label small fw-semibold mb-1">Status</label>
                                <select
                                  className={`form-select form-select-sm fw-bold bg-white ${
                                    stage.status === "completed"
                                      ? "text-success border-success"
                                      : stage.status === "current"
                                      ? "text-danger border-danger"
                                      : "text-muted"
                                  }`}
                                  value={stage.status || "pending"}
                                  onChange={(e) => {
                                    const updated = [...extraTimeline];
                                    updated[idx] = { ...updated[idx], status: e.target.value };
                                    setExtraTimeline(updated);
                                  }}
                                >
                                  <option value="completed">✓ Completed</option>
                                  <option value="current">● Current Stage (In Progress)</option>
                                  <option value="pending">○ Pending / Upcoming</option>
                                </select>
                              </div>
                              <div className="col-12 mt-2">
                                <label className="form-label small fw-semibold mb-1">Milestone Description</label>
                                <textarea
                                  className="form-control form-control-sm bg-white"
                                  rows={2}
                                  placeholder="Detailed progress info..."
                                  value={stage.description || ""}
                                  onChange={(e) => {
                                    const updated = [...extraTimeline];
                                    updated[idx] = { ...updated[idx], description: e.target.value };
                                    setExtraTimeline(updated);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Tab 2: Landmarks */}
                  {extrasActiveTab === "landmarks" && (
                    <div className="card border-0 shadow-sm rounded-3 p-3 bg-white">
                      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                        <small className="text-muted fw-bold">Manage transit connectivity and landmark distances</small>
                        <div className="d-flex gap-2">
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-primary rounded-pill px-3"
                            onClick={() => setExtraLandmarks(DEFAULT_LANDMARKS_TEMPLATE)}
                          >
                            <i className="fas fa-magic me-1"></i> Reset to Default Landmarks
                          </button>
                          <button
                            type="button"
                            className="btn btn-sm btn-primary rounded-pill px-3"
                            onClick={() =>
                              setExtraLandmarks([
                                ...extraLandmarks,
                                {
                                  landmark_name: "",
                                  category: "Expressway",
                                  distance: "",
                                  drive_time: "",
                                },
                              ])
                            }
                          >
                            <i className="fas fa-plus me-1"></i> Add Landmark
                          </button>
                        </div>
                      </div>

                      <div className="table-responsive bg-light rounded border">
                        <table className="table table-sm table-hover align-middle mb-0">
                          <thead className="table-light">
                            <tr>
                              <th style={{ minWidth: "220px" }}>Key Landmark / Transit Point</th>
                              <th style={{ minWidth: "150px" }}>Category</th>
                              <th style={{ minWidth: "100px" }}>Distance</th>
                              <th style={{ minWidth: "100px" }}>Drive Time</th>
                              <th style={{ width: "40px" }}></th>
                            </tr>
                          </thead>
                          <tbody>
                            {extraLandmarks.map((lm, idx) => (
                              <tr key={idx}>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm bg-white"
                                    placeholder="e.g. Raja Ki Mandi Railway Station"
                                    value={lm.landmark_name || ""}
                                    onChange={(e) => {
                                      const updated = [...extraLandmarks];
                                      updated[idx] = { ...updated[idx], landmark_name: e.target.value };
                                      setExtraLandmarks(updated);
                                    }}
                                  />
                                </td>
                                <td>
                                  <select
                                    className="form-select form-select-sm bg-white"
                                    value={lm.category || "Expressway"}
                                    onChange={(e) => {
                                      const updated = [...extraLandmarks];
                                      updated[idx] = { ...updated[idx], category: e.target.value };
                                      setExtraLandmarks(updated);
                                    }}
                                  >
                                    <option value="Expressway">Expressway</option>
                                    <option value="National Highway">National Highway</option>
                                    <option value="Railway">Railway</option>
                                    <option value="Metro Station">Metro Station</option>
                                    <option value="Airport Corridor">Airport Corridor</option>
                                    <option value="School">School / College</option>
                                    <option value="Hospital">Hospital</option>
                                    <option value="Commercial Hub">Commercial Hub</option>
                                    <option value="Shopping Mall">Shopping Mall</option>
                                    <option value="Bus Stand">Bus Stand</option>
                                  </select>
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm bg-white"
                                    placeholder="e.g. 4.2 km"
                                    value={lm.distance || ""}
                                    onChange={(e) => {
                                      const updated = [...extraLandmarks];
                                      updated[idx] = { ...updated[idx], distance: e.target.value };
                                      setExtraLandmarks(updated);
                                    }}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm bg-white"
                                    placeholder="e.g. 7 Mins"
                                    value={lm.drive_time || ""}
                                    onChange={(e) => {
                                      const updated = [...extraLandmarks];
                                      updated[idx] = { ...updated[idx], drive_time: e.target.value };
                                      setExtraLandmarks(updated);
                                    }}
                                  />
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-danger py-0 px-2"
                                    onClick={() => {
                                      const updated = [...extraLandmarks];
                                      updated.splice(idx, 1);
                                      setExtraLandmarks(updated);
                                    }}
                                  >
                                    <i className="fas fa-trash-alt"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>

                <div className="modal-footer bg-white rounded-bottom-4 py-3">
                  <button
                    type="button"
                    className="btn btn-outline-secondary rounded-pill px-4"
                    onClick={() => setTimelineModalOpen(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary rounded-pill px-4"
                    disabled={isSavingExtras}
                    onClick={handleSaveExtras}
                  >
                    {isSavingExtras ? (
                      <>
                        <FaSpinner className="spinner me-2" spin />
                        Saving...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-save me-2"></i>
                        Save Timeline & Landmarks
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Properties;
